import "./HealthRisks.module.css";
import Header from "@/reusable_sections/Header";
import IsItTimeToSeeASpecialist from "./sections/IsItTimeToSeeASpecialist";
import TheScienceOfBetterRest from "./sections/TheScienceOfBetterRest";
import EmergencyHelpRequest from "./sections/EmergencyHelpRequest";
import Footer from "@/reusable_sections/Footer";
export default function HealthRisksPage() {
  return <div>
      <Header />
      <IsItTimeToSeeASpecialist />
      <TheScienceOfBetterRest />
      <EmergencyHelpRequest />
      <Footer />
    </div>;
}